<template>
  <div>
    <Router-View />
  </div>
</template>

<script>
export default {
  name: 'MyRecords'
}
</script>

<style></style>
